import React from "react";
import _omit from "lodash/omit";

export default function EanNumber(props) {
  const ean = props.ean || props.gtin || props.value;

  if (!ean) {
    return <em>Keine</em>;
  }
  const formattedEanNumber = ean.toString().replace(/^0+/, "");
  if (!formattedEanNumber) {
    return <em>Keine</em>;
  }

  return (
    <span {..._omit(props, ["ean", "gtin", "value"])}>
      {formattedEanNumber}
    </span>
  );
}
